// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("./img/logo_ko_vl.png");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"logo\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> </div> <div class=\"purple-bar\"> </div>";
// Exports
module.exports = code;